<span [ngClass]="{ 'inline-title': isInlineTitle }">
  <label *ngIf="label" for="{{ inputId }}" class="title">
    {{ label }}
    <span *ngIf="isRequired" class="required">(Required)</span>
  </label>

  <div
    role="button"
    class="controls"
    [ngClass]="{
      open: isMenuOpen,
      'full-width': isFullWidth,
      disabled: isDisabled,
      invalid: isInvalid
    }"
    (click)="onClickInside(!isMenuOpen)"
    (clickOutside)="onClickOutside(false)"
    [clickOutsideExclude]="'.menu'"
  >
    <ng-content select="[searchContent]">
      <!-- menu placeholder goes here -->
    </ng-content>

    <div class="arrow" (click)="onClickArrow(); $event.stopPropagation()">
      <img
        alt=""
        src="{{
          isMenuOpen
            ? './assets/icons/dropdown/chevron-up-solid.svg'
            : './assets/icons/dropdown/chevron-down-solid.svg'
        }}"
      />
    </div>
  </div>
</span>

<div
  *ngIf="isMenuOpen || isFiltering"
  class="menu"
  [ngClass]="{ 'full-width': isFullWidth }"
>
  <ng-content select="[menuContent]">
    <!-- dropdown content goes here -->
  </ng-content>
</div>
